// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-bg[data-v-2266c266] {\n  background-color: #fafafa;\n}", ""]);
// Exports
module.exports = exports;
